import React from 'react';
import PropTypes from 'prop-types';
import { useFormik } from 'formik';
import { useDispatch } from 'react-redux';

import {
  validationSchema,
  initialValues,
  attributesToSubmit,
} from '../../../../forms/supportRequests/filtersForm';
import {
  changeStartdate,
  changeEndate,
  changeAuth0Id,
} from '../../../../store/SupportRequests/SupportRequestsSlice';

import Form from './components/Form';

const Filters = (props) => {
  const dispatch = useDispatch();
  const { searchParams, onSearchParamsChange, onLoad } = props;

  const handleSubmitFilters = async (values, _actions) => {
    const newParams = attributesToSubmit(values, searchParams);
    dispatch(changeStartdate(values.createdAfter));
    dispatch(changeEndate(values.createdBefore));
    dispatch(changeAuth0Id(values.byUser));
    onSearchParamsChange(newParams);
    onLoad(newParams);
  };

  const formik = useFormik({
    initialValues: initialValues(searchParams),
    onSubmit: handleSubmitFilters,
    enableReinitialize: true,
    validateOnChange: false,
    validateOnBlur: false,
    validationSchema,
  });

  return <Form {...formik} />;
};

export default Filters;

Filters.propTypes = {
  searchParams: PropTypes.shape().isRequired,
  onSearchParamsChange: PropTypes.func.isRequired,
  onLoad: PropTypes.func.isRequired,
};
